<template>
  <b-container fluid="sm" class="p-5 mt-5 mb-5 bg-light rounded form-container">
    <h2 class="text-center" v-if="header">
      <b-icon :icon="header.icon" class="mr-2"></b-icon>{{ header.title }}
    </h2>

    <hr class="col-xs-12" />

    <b-alert
      v-for="message in messages"
      :key="message.name"
      show
      :variant="message.variant"
    >
      {{ message.label }}
    </b-alert>

    <b-form @submit="on_submit">
      <b-row>
        <b-col class="col-12">
          <vue-form-generator
            :model="model"
            :schema="schema"
            :options="options"
            tag="div"
          >
          </vue-form-generator>
        </b-col>
      </b-row>

      <hr class="col-xs-12" />

      <FormButtons
        :buttons="buttons"
        @button_click="button_click"
      ></FormButtons>
    </b-form>
  </b-container>
</template>

<script>
import VueFormGenerator from "vue-form-generator";
import FormButtons from "./FormButtons";

export default {
  name: "Form",
  components: {
    "vue-form-generator": VueFormGenerator.component,
    FormButtons: FormButtons
  },
  methods: {
    on_submit: function(event) {
      event.preventDefault();
      this.$emit("form_submit", this.model);
    },
    button_click: function(button_name) {
      this.$emit("button_click", button_name);
    }
  },
  props: {
    header: {
      title: String,
      icon: String
    },
    model: Object,
    schema: Object,
    options: Object,
    buttons: Array,
    messages: Array
  }
};
</script>
